import { ExtensionController } from '../registry/extension';
export class PluginController extends ExtensionController {
    category = 'plugin';
    constructor(context) {
        super(context);
        this.setPlugins(this.context.options.plugins || []);
    }
    setPlugins(plugins) {
        this.setExtensions(plugins);
    }
    getPluginInstance(key) {
        return this.extensionMap[key];
    }
}
//# sourceMappingURL=plugin.js.map